// recovery-notification-status — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Agendada": "Programada",
    "Agendada para %{when}": "Programada para %{when}",
    "Aguardando envio": "Esperando envío",
    "Cancelada": "Cancelada",
    "Enviada": "Enviada",
    "Enviada com erros": "Enviada con errores",
    "Enviada em %{when}": "Enviada el %{when}",
    "Falha ao agendar": "Error al programar",
    "Falhou": "Falló",
    "Sai quando o nível começar": "Sale cuando empiece el nivel",
    "Notificação push": "Notificación push",
    "Não enviada: nenhum cliente ativo": "No enviada: ningún cliente activo",
    "Sem notificação configurada": "Sin notificación configurada",
    "Ver detalhes do envio": "Ver detalles del envío",
    "cliente(s) sem notificação push habilitada no celular ficaram de fora deste envio.": "cliente(s) sin notificación push habilitada en el celular quedaron fuera de este envío.",
    "· Disparados": "· Enviados",
    "· Erros": "· Errores",
    "· Lidos": "· Leídos",
    "· Não entregues": "· No entregadas",
    "cliente(s) não receberam: sem o app instalado ou com a notificação desligada no celular.": "cliente(s) no la recibieron: sin la app instalada o con la notificación desactivada en el celular.",
    "— detalhamento de entrega não disponível para SMS.": "— detalle de entrega no disponible para SMS.",
};

export default catalogo;
